import { jsxs, jsx } from "react/jsx-runtime";
import Button from "../../../../Button/Button.js";
import Icon from "../../../../Icon/Icon.js";
import classnames from "../../../../../utils/classnames.js";
import './ZoomControl.css';/* empty css                 */
const ZoomControl = ({ className, onUnZoom, onZoom }) => {
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-map-zoom-control", className), children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        className: classnames("perxis-auto-map-zoom-control-button"),
        type: "ghost",
        onClick: onZoom,
        icon: /* @__PURE__ */ jsx(Icon, { name: "plus", size: 20, sticker: "map-zoom-control-icon" })
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        className: classnames("perxis-auto-map-zoom-control-button"),
        type: "ghost",
        onClick: onUnZoom,
        icon: /* @__PURE__ */ jsx(Icon, { name: "minus", size: 20, sticker: "map-zoom-control-icon" })
      }
    )
  ] });
};
export {
  ZoomControl as default
};
//# sourceMappingURL=ZoomControl.js.map
